import { ExcelTemplate } from "../../interfaces";
import { WorkBook } from "xlsx-js-style";
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from "./mapping";
import { setColumnWidth, withHeaderStyling } from "../../utils";
import { fitToColumn } from "../financial-statement/utils";
import { EvaluationDataForExcel } from "src/app/domain/company-performance/business-evaluation/dto/EvaluationDataForExcel";
import {
  EvaluationHelperService,
} from '../../../company-performance/business-evaluation/service/evaluation-helper.service';
import {
  EvaluationTotalForm,
  PortfolioEvaluationForm,
} from '../../../company-performance/business-evaluation/dto/EvaluationAuxiliary';

export class BusinessEvaluationTemplate implements ExcelTemplate {

  headers = ['Parameter', 'Ranking', 'Weight', 'Score', 'Details'];

  export(data: EvaluationDataForExcel): WorkBook {
    const book = XLSX.utils.book_new();

    const companyNames = data.evaluations.map((evaluation) => evaluation.controls.companyName.value);
    const uniqueCompanyNames = [...new Set(companyNames)];

    uniqueCompanyNames.forEach((companyName) => {
      const dataByCompany = data.evaluations
        .filter((evaluation) => evaluation.controls.companyName.value === companyName);
      const total = EvaluationHelperService.countTotalWeightAndScore(dataByCompany);
      const sheet = this.getSheet(dataByCompany, total);
      XLSX.utils.book_append_sheet(book, sheet, companyName);
    });
    return book;
  }

  private getSheet(evaluations: PortfolioEvaluationForm[], total: EvaluationTotalForm): XLSX.WorkSheet {
    const preparedData = getPreparedData(evaluations, total, this.headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexes = [0];
    whiteSpaceIndexes.forEach((index) => setColumnWidth(sheet, index, 34));
    return withHeaderStyling(sheet);
  }

}
